import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	lastUpdatedBy: {
		id: 'search-page.filters.names.lastUpdatedBy',
		defaultMessage: 'Last Updated By',
		description: 'Label for filtering by creator',
	},
	confluenceFilterCreatorPlaceholder: {
		id: 'search-page.confluence.filter.creator.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for creator filter search input',
	},
	confluenceFilterCreatorLabelSelected: {
		id: 'search-page.confluence.filter.creator.selected',
		defaultMessage: 'Selected',
		description: 'Last Updated By filter selected label',
	},
	confluenceFilterCreatorLabelUnselected: {
		id: 'search-page.confluence.filter.creator.unselected',
		defaultMessage: 'Suggested',
		description: 'Last Updated By filter unselected label',
	},
});
